import { getFolders, getSubFolders, getSubFolderDetails, setSousDossierAutoImportStatus } from "@/taskpane/services/folders";
import { folderDataToFolder, subFolderDataToSubFolder } from "@/taskpane/types/folder";
import { MutationOptions, useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetFoldersQuery = (opt?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolders>>>>) =>
  useQuery({
    ...opt,
    select: (data) => {
      if (!data) {
        return null;
      }
      return {
        dossiers: data.dossiers
          ?.map((dossier) => folderDataToFolder(dossier)) || [],
        client_blocked: data.client_blocked || false,
        client_blocked_reason: data.client_blocked_reason
      };
    },
    queryFn: getFolders,
    queryKey: ["getFolders"],
  });

export const useGetSubFoldersQuery = (
  dossierId: string | null,
  opt?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubFolders>>>>
) =>
  useQuery({
    ...opt,
    select: (data) => {
      return data?.sous_dossiers?.map((subFolder) => subFolderDataToSubFolder(subFolder));
    },
    queryFn: () => {
      if (!dossierId) {
        return Promise.resolve(null);
      }
      return getSubFolders(dossierId);
    },
    queryKey: ["getSubFolders", dossierId],
    enabled: !!dossierId,
  });

export const useGetSubFolderDetailsQuery = (
  folderId: string,
  subFolderId: string,
  opt?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubFolderDetails>>>>
) =>
  useQuery({
    ...opt,
    queryFn: () => getSubFolderDetails(folderId, subFolderId),
    queryKey: ["getSubFolderDetails", folderId, subFolderId],
  });

  export const useSetSousDossierAutoImportStatus = (
    opt?: MutationOptions<Awaited<ReturnType<typeof setSousDossierAutoImportStatus>>, Error, Parameters<typeof setSousDossierAutoImportStatus>[0]>
  ) => {
    return useMutation({
      ...opt,
      mutationFn: setSousDossierAutoImportStatus,
    });
  };
